import theme from 'theme'
import { useThemeColors } from 'hooks/useThemeColors'

export const GreenZoneIcon = () => {
  const getColor = useThemeColors()

  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="10" height="10" rx="2" fill={getColor('chart-area-good')} />
    </svg>
  )
}

export const RedZoneIcon = () => {
  const getColor = useThemeColors()

  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="10" height="10" rx="2" fill={getColor('chart-area-bad')} />
    </svg>
  )
}

export const SLAIcon = () => {
  const getColor = useThemeColors()

  return (
    <svg width="20" height="2" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line
        x1="-8.74228e-08"
        y1="1"
        x2="20"
        y2="0.999998"
        stroke={getColor('text-primary')}
        strokeWidth="2"
        strokeDasharray="4 4"
      />
    </svg>
  )
}

export const TrendLineIcon = () => {
  const getColor = useThemeColors()

  return (
    <svg width="20" height="2" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="2" rx="1" fill={getColor('text-primary')} />
    </svg>
  )
}

export const PredictionLineIcon = () => (
  <svg width="20" height="2" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="2" rx="1" fill={theme.baseColors.info[30]} />
  </svg>
)
